'use client';

import React from 'react';
import { Card } from '@nextui-org/react';

import { useTrapp } from '@/hooks';

const RulesPage = () => {
  const tr = useTrapp();

  return (
    <Card className="mx-auto max-w-4xl border bg-background p-6 shadow-none">
      <h1 className="mb-1 text-2xl font-bold leading-none">
        {tr('title_rules')}
      </h1>
      <p className="mb-6 opacity-75">{tr('desc_rules')}</p>
      <div
        className="rules_content"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: tr.raw('content_rules') }}
      />
    </Card>
  );
};

export default RulesPage;
